/*
 * svnty-wall.js - THE WALL, the house's one fetch deadline (Part30, fixer W5-C).
 *
 * WHY THIS FILE EXISTS. Almost every svnty-* road sets a disabled/loading state and clears it in a `.then`
 * or `.finally`. A fetch that never settles never reaches either, so the button stays "Sending", the form
 * stays inert, the card stays on its skeleton - and on an Egyptian mobile against a cold-starting Worker
 * that is the shape of nearly every stuck state we have found. `fetch` has no timeout of its own: only an
 * AbortController gives one, and an abort lands in the caller's existing `.catch`, which already says the
 * honest words. Four files had grown their own copy of the same eight lines (svnty-account.js,
 * svnty-wallet.js, svnty-returns-desk.js, svnty-tracking.js); ten more had none. This is that helper,
 * lifted once, so a road either answers or is told to stop - never a third state where nothing happens.
 *
 * USE:  var done = wall(opts, 10000); fetch(url, opts).then(function (r) { done(); ... }, function (e) { done(); ... });
 *   - `opts` is the fetch init: the signal is written onto it, and an init that already carries a signal is
 *     left alone (a caller with its own controller keeps it).
 *   - the returned function clears the timer. Call it on BOTH arms - a timer left armed after a good answer
 *     would abort a controller nobody is listening to any more, and on some browsers log a stray error.
 *   - a browser with no AbortController (none we support, but the road must not throw) gets no wall and
 *     exactly today's behaviour.
 *
 * Loaded FIRST from snippets/svnty-head.liquid, ahead of every other deferred svnty script, so the global
 * exists before any of them run. Classic deferred scripts execute in document order; this one is in <head>
 * and every caller is later in the document. Callers still read it through a `window.svntyWall ? ... : ...`
 * arm, so a missing asset degrades to no wall rather than to a TypeError on the road.
 * No deps, ASCII only.
 */
(function () {
  'use strict';
  if (window.svntyWall) return;
  var DEFAULT_MS = 10000;   // the wall svnty-account.js and svnty-wallet.js already kept; a caller with its own budget passes it
  window.svntyWall = function (opts, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    if (ctrl && opts && !opts.signal) opts.signal = ctrl.signal;
    var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, ms > 0 ? ms : DEFAULT_MS) : null;
    return function () { if (timer) { clearTimeout(timer); timer = null; } };
  };
})();
